import {configureStore} from '@reduxjs/toolkit';
import {enableMapSet} from 'immer';
import {setupListeners} from '@reduxjs/toolkit/dist/query';

import {backendApi} from '../../api/apiGateway';

import {themeSlice} from './theme';
import {userSlice} from './user';
import {modalSlice} from './modal';
import {searchSlice} from './search';
import {clinicalSlice} from './clinical';
import {rtkQueryErrorLogger} from './middleware';

enableMapSet();

export const store = configureStore({
  reducer: {
    theme: themeSlice.reducer,
    user: userSlice.reducer,
    modal: modalSlice.reducer,
    search: searchSlice.reducer,
    clinical: clinicalSlice.reducer,
    [backendApi.reducerPath]: backendApi.reducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat([backendApi.middleware, rtkQueryErrorLogger]),
});

setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
